import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface AiMarkProps {
  className?: string;
}

/**
 * The AiMark from the design guide: every piece of AI-generated content carries one, with the
 * tooltip "AI-genererat av Anser - granska innan du agerar". 16 px, radius 5, primary tint.
 * Tokens only (`g-*`), so it follows both themes.
 */
export function AiMark({ className }: AiMarkProps) {
  const { t } = useTranslation("common");
  const label = t("ai.markTooltip");

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            role="img"
            aria-label={label}
            data-testid="ai-mark"
            className={cn(
              "inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-[5px] bg-g-primary-tint text-g-primary align-middle",
              className,
            )}
          >
            <Sparkles className="h-2.5 w-2.5" aria-hidden="true" />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top">{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
